var render = function render(_c,_vm){return _c('div',[(
      _vm.props.column === 'ExecutionPercentage' ||
      _vm.props.column === 'WeekBeforeAdvance' ||
      _vm.props.column === 'ActualWeekAdvance'
    )?_c('span',{class:{
      rojo: _vm.$options.ismenor80(_vm.props),
      amarillo: _vm.$options.ismenor100(_vm.props),
      verde: _vm.$options.is100(_vm.props)
    }},[_vm._v(_vm._s(_vm.props.rowValue)+" %")]):_vm._e(),(_vm.props.column === 'DelayedDays' && _vm.props.rowValue > 0)?_c('span',{staticClass:"rojo"},[_vm._v(" "+_vm._s(_vm.props.rowValue)+" ")]):(_vm.props.column === 'DelayedDays' && _vm.props.rowValue <= 0)?_c('span',[_vm._v(" 0 ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }